import React, { Component } from 'react';
import { browserHistory, Link } from 'react-router';
import _, { isEmpty } from 'lodash';
import moment from 'moment';
import momentTz from 'moment-timezone';
import JsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import Header from '../../components/Header';
import withGoBack from '../../common/withGoBack';
import withNotify from '../../common/withNotify';
import {
  CAPITALIZE,
  getNoneAtTop,
  getSelectedDateTime,
  onGoBack,
  // SERVER_TIMEZONE,
  sortData
} from '../../common/globals';
import withSelectCaseDate from '../../common/withSelectCaseDate';
import EditCaseDetail from '../../components/EditCaseDetail';
import CancelCaseModal from '../../components/Models/CancelCaseModal';
import CaseSubmitted from '../../components/Models/CaseSubmitted';
import TypeChangeConfirmationModal from '../../components/Models/TypeChangeConfirmationModal';
import MrnOrPatientIdModal from '../../components/Models/MrnOrPatientIdModal';
import withOnline from '../../common/withOnline';
import withLoader from '../../common/withLoader';
import withTableName from '../../common/withTableName';
import withTeam from '../../common/withTeam';
import withSetsListStateStorage from '../../common/withSetsListStateStorage';
import withSelectedSetsPayload from '../../common/withSelectedSetsPayload';
import {
  deleteCaseByCaseId,
  getCaseByCaseScheduleID,
  getCaseType,
  getCustomerNoByName,
  getGenderType,
  getHospitalByCustomerNo,
  getProcedureTypes,
  getSideType,
  getSurgeons,
  getTableCaseByCaseId,
  getTeamReps,
  getVhnPpcValue,
  insertComplianceApp, singleManageCaseAdd,
  updateCaseByCaseScheduleID,
  updateTableCaseByPrimaryId,
  updateTableWiseCaseByCaseId,
  updateCaseByPrimaryId
} from '../../utils/db';
import {
  addComplianceAppData, cancelCase, generateBulkTimedURL, listSingleCase, updateCase
} from '../../utils/utils';
import Bugsnag from '../../helpers/bugsnag';
import RequiredMrnOrPatientId from '../../components/Models/RequiredMrnOrPatientId';
import ZeroProductSubmitModal from '../../components/Models/ZeroProductSubmitModal';
import AgeInputLimitModal from '../../components/Models/AgeInputLimit';
import AlreadySubmittedCase from '../../components/Models/AlreadySubmittedCase';
import CaseChangesNoLonger from '../../components/Models/CasesChangesNoLonger';
import QuickEditChangesNoLonger from '../../components/Models/QuickEditChangesNoLonger';
import PatientAndMrnEditOffline from '../../components/Models/PatientAndMrnEditOffline';
import withUser from '../../common/withUser';
import ACMProductGoBackModal from '../../components/Models/ACMProductGoBackModal';
import VhnPpcModal from '../../components/Models/VhnPpcModal';
import withVhnPpcOtherCharge from '../../common/withVhnPpcOtherCharge';
import VrasPpcModal from '../../components/Models/VrasPpcModal';
// import ReportLogo from '../../assets/images/white_report_logo.png';
import ReportDarkLogo from '../../assets/images/dark_report_logo.png';
import Printer from '../../assets/images/printer-outline-custom.png';
import OpenSans from '../../assets/fonts/OpenSans.ttf';
import OpenSansBold from '../../assets/fonts/OpenSans-Bold.ttf';
import withThemeColor from '../../common/withThemeColor.js';
import CustCaseIDModal from '../../components/Models/CustCaseIDModal';
import RequiredCustCaseID from '../../components/Models/RequiredCustCaseID';

const isEditCaseDetail = {
  age: false,
  repNote: false,
  officeNote: false,
  weight: false,
  repPo: false,
  gender: false,
  mra: false,
  height: false,
  rep: false,
  hospital: false,
  SurgeonName: false
};

class ManageCaseDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: {},
      caseDetail: {},
      manageCaseDetail: {},
      previousType: '',
      isEditDetail: _.cloneDeep(isEditCaseDetail),
      editValue: '',
      types: [],
      sides: [],
      coverReps: [],
      procedures: [],
      hospitals: [],
      surgeons: [],
      genders: [],
      selectedDate: new Date(),
      selectedTime: new Date(),
      caseRes: {},
      age: '',
      customerNo: '',
      previousPage: '',
      xRayFileUrlData: [],
      hospitalUseCustCaseIDStatus: false,
    };
    this.onlineAlertModal = null;
    this.typeChangeConfirmationModal = null;
    this.mrnOrPatientModal = null;
    this.requiredmrnOrPatientModal = null;
    this.caseSubmittedModal = null;
    this.caseSubmittedModal = null;
    this.zeroProductSubmitModal = null;
    this.ageInputLimitModal = null;
    this.alreadySubmittedCase = null;
    this.caseChangesNoLonger = null;
    this.quickEditChangesNoLonger = null;
    this.patientAndMrnEditOfflineModal = null;
    this.cancelCaseModal = null;
    this.internalServerErrorModal = null;
    this.saveChangesConfirmation = null;
    this.vhnPpcModal = null;
    this.vrasPpcModal = null;
    this.dgrRequiredOnSubmitCaseModal = null;
    this.custCaseIDModal = null;
    this.requiredCustCaseIDModal = null;
  }

  componentDidMount() {
    try {
      const { setSetsListStateStorage, setSelectedSetsPayload } = this.props;
      setSetsListStateStorage({});
      setSelectedSetsPayload([]);
      // goBack.push(window.location.pathname);
      // setGoBack(goBack);

      this.onlineAlertModal = new window.bootstrap.Modal(window.$('#onlineInfoModal'));
      this.typeChangeConfirmationModal = new window.bootstrap.Modal(window.$('#typeChangeConfirmationModal'));
      this.mrnOrPatientModal = new window.bootstrap.Modal(window.$('#mrnOrPatientIdModal'));
      this.requiredmrnOrPatientModal = new window.bootstrap.Modal(window.$('#requiredMrnOrPatientId'));
      this.caseSubmittedModal = new window.bootstrap.Modal(window.$('#caseSubmittedModal'));
      this.zeroProductSubmitModal = new window.bootstrap.Modal(window.$('#zeroProductSubmitModal'));
      this.ageInputLimitModal = new window.bootstrap.Modal(window.$('#ageInputLimit'));
      this.alreadySubmittedCase = new window.bootstrap.Modal(window.$('#alreadySubmittedCase'));
      this.caseChangesNoLonger = new window.bootstrap.Modal(window.$('#CaseChangesNoLongerModal'));
      this.quickEditChangesNoLonger = new window.bootstrap.Modal(window.$('#quickEditChangesNoLongerModal'));
      this.patientAndMrnEditOfflineModal = new window.bootstrap.Modal(window.$('#patientAndMrnEditOfflineModal'));
      this.cancelCaseModal = new window.bootstrap.Modal(window.$('#cancelCaseModal'));
      this.internalServerErrorModal = new window.bootstrap.Modal(window.$('#internalServerErrorModal'));
      this.saveChangesConfirmation = new window.bootstrap.Modal(window.$('#acmProductGoBackModal'));
      this.vhnPpcModal = new window.bootstrap.Modal(window.$('#vhnPpcModalModal'));
      this.vrasPpcModal = new window.bootstrap.Modal(window.$('#vrasPpcModal'));
      this.dgrRequiredOnSubmitCaseModal = new window.bootstrap.Modal(window.$('#dgrRequiredOnSubmitCaseModal'));
      this.custCaseModal = new window.bootstrap.Modal(window.$('#custCaseIDModal'));
      this.requiredCustCaseIDModal = new window.bootstrap.Modal(window.$('#requiredCustCaseID'));
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  async componentDidUpdate(prevProps) {
    if (prevProps.online !== this.props.online) {
      await this._getFiles();
    }
  }

  _getSurgeon = async () => {
    try {
      const surgeonRes = await getSurgeons();
      const sortSurgeons = sortData(surgeonRes, 'SurgeonName');
      this.setState({
        surgeons: sortSurgeons
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _getHospital = () => {
    try {
      const { surgeons, caseDetail } = this.state;
      const hospitalFilterRes = surgeons.filter(
        (obj) => obj.SurgeonName.toString() === caseDetail.SurgeonName
      );
      // const sortHospitals = sortData(hospitalFilterRes, 'CustomerName');
      // Hospital API response get by Surgeon id
      hospitalFilterRes.map((hospital) => {
        this.setState({ tempHospitals: hospital.surgeon_hospitals }, async () => {
          const customerNosRes = [];
          this.state.tempHospitals.forEach((obj) => {
            customerNosRes.push(obj.CustomerNo);
          });
          let newData = [];
          customerNosRes.map(async (item) => {
            const hospitalRes = await getHospitalByCustomerNo(item);
            if (!isEmpty(hospitalRes)) {
              newData.push(hospitalRes);
              const filtered = [];
              for (let i = 0; i < newData.length; i++) {
                let isHasNotEqual = true;
                for (let j = 0; j < filtered.length; j++) {
                  if (filtered[j].CustomerNo === newData[i].CustomerNo) {
                    isHasNotEqual = false;
                  }
                }
                if (isHasNotEqual) {
                  filtered.push(newData[i]);
                }
              }
              newData = filtered;
              this.setState({
                hospitals: sortData(newData, 'CustomerName'),
              }, () => {
                $('#hospitalsEle').select2('open');
              });
            }
          });
        });
      });
      // hospitalFilterRes.map((hospitalRes) => {
      //   this.setState({
      //     hospitals: sortData(hospitalRes.surgeon_hospitals, 'CustomerName'),
      //   }, () => {
      //     $('#hospitalsEle').select2('open');
      //   });
      // });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _getCustomerNo = async (name) => {
    try {
      const customerNoRes = await getCustomerNoByName(name);
      this.setState({
        customerNo: customerNoRes.CustomerNo
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _getCaseType = async () => {
    try {
      const typeRes = await getCaseType();
      const sortType = sortData(typeRes, 'OptionName');
      this.setState({
        types: sortType
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _getProcedureTypes = async () => {
    try {
      const procedureTypesRes = await getProcedureTypes();
      this.setState({
        procedures: procedureTypesRes
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _getTeamReps = async () => {
    try {
      const { user: { name }, team: { salesAccess } } = this.props;
      const teamRepsRes = await getTeamReps();
      salesAccess && teamRepsRes.push({ SalesRepName: salesAccess ? name : '' });
      const sortTeamReps = sortData(teamRepsRes, 'SalesRepName');
      sortTeamReps.unshift({ SalesRepName: 'NONE' });
      this.setState({
        coverReps: sortTeamReps
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _getSideType = async () => {
    try {
      const sideTypeRes = await getSideType();
      const sortSideType = sortData(sideTypeRes, 'OptionName');
      const sideSortByNoneRes = await getNoneAtTop(sortSideType, 'OptionName');
      this.setState({
        sides: sideSortByNoneRes
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _getGenderType = async () => {
    try {
      const genderTypeRes = await getGenderType();
      const sortGenderType = sortData(genderTypeRes, 'OptionName');
      const genderSortByNoneRes = await getNoneAtTop(sortGenderType, 'OptionName');
      this.setState({
        genders: genderSortByNoneRes
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onGoBack = () => {
    try {
      const { caseDetail, previousType } = this.state;
      this.setState({ previousType: caseDetail.CaseType });
      if (previousType !== caseDetail.CaseType && caseDetail.case_sets.length > 0) {
        this.typeChangeConfirmationModal.show();
      } else {
        this._onSaveChanges();
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onPrint = () => {
    try {
      const { caseDetail, selectedDate, selectedTime } = this.state;
      const { themeColor } = this.props;
      const documentTitle = `${(caseDetail.CaseNo ? caseDetail.CaseNo : caseDetail.CaseScheduleID)}.pdf`;
      const doc = new JsPDF({
        unit: 'cm',
      });
      const docuemntConstants = {
        headerHeight: 3,
      };
      doc.setProperties({
        title: documentTitle,
      });
      doc.addFont(OpenSans, 'OpenSans', 'normal');
      doc.addFont(OpenSansBold, 'OpenSans', 'bold');
      doc.setFont('OpenSans');
      const addHeader = (document) => {
        document.addImage((themeColor === 'light' ? ReportDarkLogo : ReportDarkLogo), 'PNG', 2, 1.5, 3.5, 0.7);
        document.setFontSize(9);
        document.text(`pdf generated: ${moment().format('YYYY-MM-DD HH:mm:ss')}`, 19, 1.85, {
          align: 'right',
        });
        document.setDrawColor('#808080');
        document.setLineWidth(0.05);
        document.rect(0.5, 0.5, 20, 28.5);
      };
      const firstTableData = [
        [{ content: 'Case ID:' }, caseDetail.CaseNo || 'PENDING'],
        ['Date:',
          `${moment(selectedDate)
            .format('ddd MMM DD, YYYY') || ''} ${moment(selectedTime).format('h:mm A')}`],
        ['Surgeon:', caseDetail.SurgeonName || ''],
        ['Hospital:', caseDetail.CustomerName || ''],
        ['Rep:', caseDetail.CoverRep || ''],
        ['Type:', (caseDetail.CaseType || '')
          + (caseDetail.ProcedureType ? `, ${caseDetail.ProcedureType}` : '')
          + (caseDetail.Side ? `, ${caseDetail.Side}` : '')],
        ['Gender:', caseDetail.Gender || ''],
        ['Age:', caseDetail.Age || ''],
        ['Height:', caseDetail.Height || ''],
        ['Weight:', caseDetail.Weight || ''],
        ['Rep PO#:', caseDetail.RepPONumber || ''],
        ['X-Rays:', caseDetail.case_xrays ? `${caseDetail.case_xrays.length} available` : ''],
        ['Rep Notes:', caseDetail.RepNotes || ''],
        ['Office Notes:', caseDetail.Comments || ''],
      ];
      if (caseDetail.ACMCaseFlags !== null) {
        firstTableData.splice(1, 0, ['ACM Flag:', 'True']);
        firstTableData.push(['Clinical Notes:', caseDetail.SurgeonNotes || '']);
        const plannedTemplate = this._getPlannedTemplate();
        firstTableData.push(['Templated:', plannedTemplate || '']);
      }
      autoTable(doc, {
        margin: {
          top: docuemntConstants.headerHeight, left: 2, right: 2, bottom: 2
        },
        styles: {
          font: 'OpenSans',
          fontSize: 10,
          lineWidth: 0,
          cellPadding: 0.1,
        },
        body: firstTableData,
        theme: 'plain',
        showHead: 'everyPage',
        columnStyles: {
          0: { cellWidth: 2.5 },
        },
        didDrawPage: () => {
          addHeader(doc);
        }
      });

      let { finalY } = doc.lastAutoTable;
      if (finalY + 3 > doc.internal.pageSize.height) {
        doc.addPage();
        finalY = docuemntConstants.headerHeight;
      }
      doc.setFontSize(10);
      doc.setFont('OpenSans', 'bold');
      doc.text('Office Sets:', 2, finalY + 1);
      doc.setFont('OpenSans', 'normal');
      const officeSets = this._getOfficeSets();
      Object.keys(officeSets).forEach((key, index) => {
        // final Y + 2 for the title + 1 for each row and one additional row for the total
        const estimatedSize = finalY + 2 + (officeSets[key].length + 1) * 1;
        if (estimatedSize > doc.internal.pageSize.height) {
          doc.addPage();
          finalY = 3;
        }
        if (index === 0) {
          doc.text(`${key[0] + key.slice(1).toLowerCase()}s`, 2, finalY + 1.5);
          finalY += 1.5;
        } else {
          doc.text(`${key[0] + key.slice(1).toLowerCase()}s`, 2, finalY + 1);
          finalY += 1;
        }
        const bodyData = officeSets[key].map((set) => [
          set.SetName,
          { content: set.Quantity, styles: { halign: 'center' } },
        ]);
        bodyData.push(['', {
          content: officeSets[key].reduce((acc, set) => acc + parseInt(set.Quantity, 10), 0),
          styles: { halign: 'center' }
        }]);
        autoTable(doc, {
          margin: {
            top: docuemntConstants.headerHeight,
            left: 2,
            right: 2
          },
          startY: finalY + 0.2,
          theme: 'grid',
          tableLineWidth: 0,
          cellWidth: 'wrap',
          styles: {
            font: 'OpenSans',
            fontSize: 10,
            lineColor: '#000000',
            lineWidth: 0.04,
            cellPadding: 0.1,
          },
          didDrawPage: (HookData) => {
            addHeader(doc);
            HookData.settings.startY = 0;
            finalY = 4;
          },
          body: bodyData,
        });
        finalY = doc.lastAutoTable.finalY;
      });
      if (window.mobileCheck()) {
        doc.save(documentTitle);
      } else {
        doc.output('dataurlnewwindow', documentTitle);
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _getOfficeSets = () => {
    try {
      const { caseRes } = this.state;
      if (Object.keys(caseRes).length > 0) {
        const result = [...caseRes.case_sets.reduce((mp, o) => {
          if (!mp.has(o.SetName)) mp.set(o.SetName, { ...o, count: 0 });
          mp.get(o.SetName).count++;
          return mp;
        }, new Map()).values()];
        const groupByData = _.groupBy(result, 'DeviceType');
        return Object.keys(groupByData)
          .sort()
          .reduce((accumulator, key) => {
            accumulator[key] = groupByData[key];

            return accumulator;
          }, {});
      }
      return [];
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  _getPlannedTemplate = () => {
    const { caseDetail: { ACMPlannedParts } } = this.state;
    const plannedArr = [];
    const ACMPlannedArray = ACMPlannedParts.split(';');
    ACMPlannedArray.map((value) => {
      plannedArr.push(value.split(','));
    });
    const plannedValue = plannedArr.slice(0).map(
      ([productId, bodyComponent, confidence, isTemplated, shortDesc, longDesc]) => ({
        productId, bodyComponent, confidence, isTemplated, shortDesc, longDesc
      })
    );

    const templatedPlannedData = [];
    for (const planned of plannedValue) {
      if (!_.isEmpty(planned.longDesc)) {
        templatedPlannedData.push(planned);
      }
    }
    return templatedPlannedData.map((planned) => planned.longDesc).join(', ');
  }

  _onAngeInputChange = async () => {
    try {
      const { params } = this.props;
      if (params.hasOwnProperty('caseId')) {
        await this._getCaseById();
      }
      this.ageInputLimitModal.hide();
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onCancelTypeChange = async () => {
    try {
      const { params } = this.props;
      if (params.hasOwnProperty('caseId')) {
        await this._getCaseById();
      }
      this._onSaveChanges();
      this.typeChangeConfirmationModal.hide();
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onSaveChanges = async () => {
    try {
      const {
        goBack, setGoBack, setSelectCaseDate, notify, online, setLoader, tableName, user: { name }
      } = this.props;
      const {
        caseDetail, isEditDetail, manageCaseDetail, previousPage, customerNo
      } = this.state;
      if (Object.values(isEditDetail).some((key) => key === true)) {
        if (caseDetail.CaseType === '') {
          notify({ type: 'error', message: 'Please select type' });
        } else if (caseDetail.SurgeonName === '') {
          notify({ type: 'error', message: 'Please select surgeon' });
        } else if (caseDetail.CustomerName === '') {
          notify({ type: 'error', message: 'Please select hospital' });
        } else if (caseDetail.ProcedureType === '') {
          notify({ type: 'error', message: 'Please select procedure' });
        } else {
          this.setState({
            isEditDetail: _.cloneDeep(isEditCaseDetail)
          });

          if (JSON.stringify(caseDetail) !== JSON.stringify(manageCaseDetail)) {
            caseDetail.Submitted = '0';
          }
          // updateCaseByCaseId(caseDetail.id, caseDetail);
          // if (caseDetail && caseDetail.DGR === '1') {
          //   this.caseChangesNoLonger.show();
          //   // setLoader(false);
          //   return;
          // }
          if (caseDetail.Age > 120) {
            this.ageInputLimitModal.show();
            return;
          }
          setLoader(true);
          if (online) {
            const {
              CaseScheduleID, CaseDate, CaseTime, CustomerNo, CustomerName, SurgeonName,
              PatientID, ProcedureType, CaseType, Side, Comments, RepNotes, ProductNotes,
              ProductSubmitted, RepPONumber, Submitted, CoverRep, ChangeRep, DGRUpload,
              MRN, Gender, Age, ACMPlannedParts, ACMSelectedParts, Height, Weight, selectedSets,
              ...partialObject
            } = caseDetail;
            const subset = {
              CaseScheduleID,
              CaseDate,
              CaseTime,
              CustomerNo: customerNo === '' ? CustomerNo : customerNo,
              CustomerName,
              SurgeonName,
              PatientID: (PatientID !== null) ? (PatientID.toUpperCase()) : null,
              ProcedureType,
              CaseType,
              Side,
              Comments: (Comments !== null) ? CAPITALIZE(Comments) : null,
              RepNotes: (RepNotes !== null) ? CAPITALIZE(RepNotes) : null,
              ProductNotes,
              ProductSubmitted,
              RepPONumber,
              Submitted,
              CoverRep,
              ChangeRep: name,
              DGRUpload,
              MRN,
              Gender,
              Age,
              ACMPlannedParts,
              ACMSelectedParts,
              Height,
              Weight,
              selectedSets
            };

            if (Object.values(isEditDetail).some((key) => key === true)) {
              // Set case time based on server timezone
              const selectedDateTime = await getSelectedDateTime(
                caseDetail.CaseDate, caseDetail.CaseTime
              );

              caseDetail.CaseDate = moment(selectedDateTime).format('YYYY-MM-DD');
              caseDetail.CaseTime = moment(selectedDateTime).format('HH:mm');
              if (JSON.stringify(caseDetail.CaseType)
                !== JSON.stringify(manageCaseDetail.CaseType)) {
                subset.selectedSets = [];
                subset.case_sets = [];
              } else {
                const newArrayOfObj = partialObject.case_sets.map(({
                  CasePlanId: CasePlanID,
                  ...rest
                }) => ({
                  CasePlanID,
                  ...rest
                }));
                subset.selectedSets = newArrayOfObj;
              }

              updateCase(subset).then(async (responseJson) => {
                setLoader(false);
                const { status, message } = responseJson;
                if (status) {
                  if (message.length > 0) {
                    // notify({ type: 'success', message });
                  }
                  // Update into local db
                  await updateTableWiseCaseByCaseId(
                    caseDetail.id, { ...caseDetail, ...subset }, tableName
                  );
                  const caseRes = await this._getCase();
                  if (Object.keys(caseRes).length > 0) {
                    this.setState({
                      caseRes,
                      caseDetail: { ...caseDetail, ...subset }
                    });
                  }
                  if (tableName !== 'Cases') {
                    const getCaseByCaseId = await getCaseByCaseScheduleID(
                      caseDetail.CaseScheduleID
                    );
                    caseDetail.id = getCaseByCaseId.id;
                    subset.id = getCaseByCaseId.id;
                    await updateCaseByCaseScheduleID(
                      caseDetail.CaseScheduleID, { ...caseDetail, ...subset }
                    );
                  }
                  setLoader(false);
                } else {
                  notify({ type: 'error', message });
                }
              });
            }
          } else {
            if (isEditDetail.PatientID || isEditDetail.MRN) {
              caseDetail.Sync = 1;
              updateTableWiseCaseByCaseId(caseDetail.id, caseDetail, tableName);
            } else {
              setLoader(true);
              const caseRes = await getTableCaseByCaseId(caseDetail.id, tableName);

              if (Object.keys(caseRes).length > 0) {
                this.setState({
                  caseRes
                }, () => {
                  notify({ type: 'error', message: 'You need an internet connection to edit this case.', time: 5 });
                });
              }
            }
            setLoader(false);
          }
        }
      } else {
        // if (caseDetail && caseDetail.DGR === '1') {
        //   notify({ type: 'error', message: 'Changes no longer be made to this case.' });
        //   return;
        // }
        if (online) {
          goBack.push(window.location.pathname);
          browserHistory.push(`/manage-case/${caseDetail.id}/edit`);
          if (tableName === 'Cases') {
            setSelectCaseDate(new Date(caseDetail.CaseDate.replace(/-/g, '/')));
          }
          setGoBack(goBack);
        } else if (!moment(caseDetail.CaseDate, 'YYYY-MM-DD').isSameOrBefore()) {
          notify({ type: 'error', message: 'This case can no longer be edited while offline.' });
        } else {
          this.patientAndMrnEditOfflineModal.show();
        }
        if (tableName === 'Cases') {
          setSelectCaseDate(new Date(caseDetail.CaseDate.replace(/-/g, '/')));
        }
        setGoBack(goBack);
      }
      if (previousPage === 'previousPage') {
        if (caseDetail.CustomerName === '') {
          notify({ type: 'error', message: 'Please select hospital' });
        } else {
          onGoBack(goBack);
        }
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onClickOk = async () => {
    try {
      const { goBack } = this.props;
      const caseDetail = await this._getCase();
      goBack.push(window.location.pathname);
      browserHistory.push(`/manage-case/${caseDetail.id}/edit`);
      this.patientAndMrnEditOfflineModal.hide();
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onBillingDetails = () => {
    try {
      const { online, goBack } = this.props;
      const { caseDetail: { id } } = this.state;
      if (online) {
        goBack.push(window.location.pathname);
        browserHistory.push(`/billing-detail/${id}`);
      } else {
        this.onlineAlertModal.show();
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onSetsClick = async () => {
    try {
      const { goBack } = this.props;
      const caseDetail = await this._getCase();
      goBack.push(window.location.pathname);
      browserHistory.push(`/manage-case/${caseDetail.id}/sets`);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onChangeCaseDetail = (key, value) => {
    try {
      const { caseDetail } = this.state;
      caseDetail[key] = value;
      if (caseDetail && caseDetail.DGR === '1') {
        this.quickEditChangesNoLonger.show();
        return;
      }

      if (key === 'SurgeonName') {
        caseDetail.CustomerName = '';
        this._getHospital();
      }
      if (key === 'selectedDate') {
        this.setState({ selectedDate: value });
        caseDetail.CaseDate = moment(value).format('YYYY-MM-DD');
      }
      if (key === 'selectedTime') {
        this.setState({ selectedTime: value });
        caseDetail.CaseTime = moment(value).format('HH:mm');
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onEditCaseDetail = (key, value) => {
    try {
      const { isEditDetail } = this.state;
      isEditDetail[key] = value;
      this.setState({ isEditDetail }, () => this._onFocusAndBlur());
      this._onRepNotesFocusAndBlur();
      this._onOfficeNotesFocusAndBlur();
      this._onSelect2FocusAndBlur();
      this._onHospitalFocusAndBlur();
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _getCaseById = async () => {
    try {
      const { notify } = this.props;
      const caseRes = await this._getCase();

      if (Object.keys(caseRes).length > 0) {
        // Get case time
        const currentDate = new Date();
        const timeValues = caseRes.CaseTime.split(':');

        let CaseDateTime;
        let NewTime;
        if (timeValues.length === 2) {
          CaseDateTime = currentDate.setHours(timeValues[0], timeValues[1]);
          NewTime = new Date(CaseDateTime);
        } else {
          CaseDateTime = caseRes.CaseTime;
          NewTime = CaseDateTime;
        }

        this.setState({
          caseDetail: caseRes,
          previousType: caseRes.CaseType,
          manageCaseDetail: { ...caseRes },
          selectedDate: new Date(caseRes.CaseDate.replace(/-/g, '/')),
          selectedTime: NewTime
        });
      } else {
        notify({ type: 'error', message: 'Case record not found.' });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onCaseCancel = async () => {
    try {
      const {
        notify, setLoader, online, goBack
      } = this.props;
      const caseRes = await this._getCase();

      if (caseRes && caseRes.DGR === '1') {
        setLoader(true);
        this.quickEditChangesNoLonger.show();
        setLoader(false);
        return;
      }

      if (online) {
        const cancelCaseRes = await cancelCase(caseRes.CaseScheduleID);
        const { message, status } = cancelCaseRes;
        if (status) {
          setLoader(true);
          if (message.length > 0) {
            // notify({ type: 'success', message });
          }
          await deleteCaseByCaseId(caseRes.id);
          onGoBack(goBack);
        } else {
          notify({ type: 'error', message });
        }
        setLoader(false);
      } else {
        // setLoader(true);
        // await deleteCaseByCaseId(caseRes.id);
        // browserHistory.push('/manage-cases');
        // setLoader(false);
        notify({ type: 'error', message: 'You must have an internet connection. Please check your connection and try again.', time: 5 });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  _onCancelCase = () => {
    try {
      const { online, notify } = this.props;
      if (online) {
        this.cancelCaseModal.show();
      } else {
        notify({ type: 'error', message: 'You must have an internet connection. Please check your connection and try again.', time: 3 });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onCancelCaseBack = () => {
    try {
      this.cancelCaseModal.hide();
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onAddPatientIdOrMrn = () => {
    try {
      this.mrnOrPatientModal.show();
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onOpenCustomerCaseModal = async () => {
    try {
      const {
        params: { caseId },
        tableName
      } = this.props;

      const caseRes = await getTableCaseByCaseId(caseId, tableName);

      if (typeof caseRes.CustomerNo !== 'undefined' && caseRes.CustomerNo !== null) {
        const hosptalRes = await getHospitalByCustomerNo(caseRes.CustomerNo);

        if (hosptalRes.UseCustCaseID === '1') {
          this.setState({
            hospitalUseCustCaseIDStatus: true
          });
          this._onCustomerCaseIDStatus();
        }
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onCustomerCaseIDStatus = () => {
    try {
      const custCaseIDStatus = new window.bootstrap.Modal(window.$('#custCaseIDModal'));
      custCaseIDStatus.show();
    } catch (error) {
      Bugsnag.notify(error);
    }
  }

  _onNextCustomerCaseIDStatus = () => {
    try {
      const custCaseIDStatus = new window.bootstrap.Modal(window.$('#requiredCustCaseID'));
      custCaseIDStatus.show();
    } catch (error) {
      Bugsnag.notify(error);
    }
  }

  _onNextAddPatientIdOrMrn = () => {
    try {
      this.requiredmrnOrPatientModal.show();
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onAddVhnPpc = async () => {
    try {
      const caseDetail = await this._getCase();
      if (caseDetail.VelysUsed === null) {
        // if (caseDetail.case_products.length > 0) {
        // const vhnProductNo = caseDetail.case_products.find((e) => e.ProductNo === '099995000');
        // if (_.isEmpty(vhnProductNo)) {
        this.vhnPpcModal.show();
      } else if (caseDetail.case_products.length > 0) {
        this._onGoBackButton();
        browserHistory.push(`/manage-case/${caseDetail.id}/products/list`);
      } else {
        this._onGoBackButton();
        browserHistory.push(`/manage-case/${caseDetail.id}/products/add`);
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onGoBackButton = () => {
    try {
      const { goBack, setGoBack } = this.props;
      goBack.push(window.location.pathname);
      setGoBack(goBack);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onClickVhnPpcYes = async () => {
    try {
      const {
        tableName, setVhnPpcOtherCharge, setLoader, online,
        user: { name, territories, office }
      } = this.props;
      const caseDetail = await this._getCase();
      let vhnPpcValue = {};
      if (caseDetail.CustomerName !== null) {
        const vhnPpc = await getVhnPpcValue(caseDetail.CustomerName);
        if (typeof vhnPpc !== 'undefined') {
          vhnPpcValue = vhnPpc;
        }
      }
      const territoriesData = territories.find((item) => item.offices.some(
        (value) => value.id === office
      ));
      const officeData = territoriesData.offices.find((o) => o.id === office);
      const complainAppData = {
        CaseScheduleID: caseDetail.CaseScheduleID,
        OfficeName: officeData.name,
        RepCaseNo: caseDetail.RepCaseNo,
        UserName: name,
        ComplianceType: vhnPpcValue.VHN_PPC === '1' ? 'VHN-PPC' : 'VHN-Other',
        UserResponse: 'YES',
        // ResponseDate: momentTz(new Date()).tz(SERVER_TIMEZONE).format('YYYY-MM-DD HH:mm:ss.SSS'),
        ResponseDate: momentTz(new Date()).format('YYYY-MM-DD HH:mm:ss.SSS'),
        Sync: online ? 0 : 1
      };
      setLoader(true);
      setVhnPpcOtherCharge(true);
      if (online) {
        await addComplianceAppData({
          CaseScheduleID: caseDetail.CaseScheduleID,
          ComplianceType: complainAppData.ComplianceType,
          UserResponse: complainAppData.UserResponse
        })
          .then(async (response) => {
            if (response.message === 'VHN Compliance added successsfully') {
              await insertComplianceApp(complainAppData);
              const newArrayOfObj = caseDetail.case_sets.map(({
                CasePlanId: CasePlanID,
                ...rest
              }) => ({
                CasePlanID,
                ...rest
              }));
              caseDetail.selectSets = newArrayOfObj;
              caseDetail.Submitted = '0';
              caseDetail.Synced = '0';
              caseDetail.VelysUsed = 'YES';
              await updateCase(caseDetail);
              updateTableWiseCaseByCaseId(caseDetail.id, caseDetail, tableName);
              if (complainAppData.ComplianceType === 'VHN-PPC') {
                this._onGoBackButton();
                browserHistory.push(`/manage-case/${caseDetail.id}/products/add/other-charge`);
              } else {
                this._onGoBackButton();
                browserHistory.push(`/manage-case/${caseDetail.id}/products/add`);
              }
            }
          });
      } else {
        await insertComplianceApp(complainAppData);
        caseDetail.Submitted = '0';
        caseDetail.Synced = '0';
        caseDetail.VelysUsed = 'YES';
        caseDetail.Sync = 1;
        updateTableWiseCaseByCaseId(caseDetail.id, caseDetail, tableName);
        if (complainAppData.ComplianceType === 'VHN-PPC') {
          this._onGoBackButton();
          browserHistory.push(`/manage-case/${caseDetail.id}/products/add/other-charge`);
        } else {
          this._onGoBackButton();
          browserHistory.push(`/manage-case/${caseDetail.id}/products/add`);
        }
      }
      setLoader(false);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onClickVhnPpcNo = async () => {
    try {
      const {
        tableName, setLoader, online,
        user: { name, territories, office }
      } = this.props;
      const caseDetail = await this._getCase();
      let vhnPpcValue = {};
      if (caseDetail.CustomerName !== null) {
        const vhnPpc = await getVhnPpcValue(caseDetail.CustomerName);
        if (typeof vhnPpc !== 'undefined') {
          vhnPpcValue = vhnPpc;
        }
      }
      const territoriesData = territories.find((item) => item.offices.some(
        (value) => value.id === office
      ));
      const officeData = territoriesData.offices.find((o) => o.id === office);
      const complainAppData = {
        CaseScheduleID: caseDetail.CaseScheduleID,
        OfficeName: officeData.name,
        RepCaseNo: caseDetail.RepCaseNo,
        UserName: name,
        ComplianceType: vhnPpcValue.VHN_PPC === '1' ? 'VHN-PPC' : 'VHN-Other',
        UserResponse: 'NO',
        // ResponseDate: momentTz(new Date()).tz(SERVER_TIMEZONE).format('YYYY-MM-DD HH:mm:ss.SSS'),
        ResponseDate: momentTz(new Date()).format('YYYY-MM-DD HH:mm:ss.SSS'),
        Sync: online ? 0 : 1
      };
      setLoader(true);
      if (online) {
        await addComplianceAppData({
          CaseScheduleID: caseDetail.CaseScheduleID,
          ComplianceType: complainAppData.ComplianceType,
          UserResponse: complainAppData.UserResponse
        })
          .then(async (response) => {
            if (response.message === 'VHN Compliance added successsfully') {
              await insertComplianceApp(complainAppData);
              const newArrayOfObj = caseDetail.case_sets.map(({
                CasePlanId: CasePlanID,
                ...rest
              }) => ({
                CasePlanID,
                ...rest
              }));
              caseDetail.selectSets = newArrayOfObj;
              caseDetail.Submitted = '0';
              caseDetail.Synced = '0';
              caseDetail.VelysUsed = 'NO';
              await updateCase(caseDetail);
              updateTableWiseCaseByCaseId(caseDetail.id, caseDetail, tableName);
              this._onGoBackButton();
              browserHistory.push(`/manage-case/${caseDetail.id}/products/add`);
            }
          });
      } else {
        await insertComplianceApp(complainAppData);
        caseDetail.Submitted = '0';
        caseDetail.Synced = '0';
        caseDetail.VelysUsed = 'NO';
        caseDetail.Sync = 1;
        updateTableWiseCaseByCaseId(caseDetail.id, caseDetail, tableName);
        this._onGoBackButton();
        browserHistory.push(`/manage-case/${caseDetail.id}/products/add`);
      }
      setLoader(false);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onAddVrasPpc = async () => {
    try {
      const caseDetail = await this._getCase();
      if (caseDetail.VelysUsed === null) {
        this.vrasPpcModal.show();
      } else if (caseDetail.case_products.length > 0) {
        this._onGoBackButton();
        browserHistory.push(`/manage-case/${caseDetail.id}/products/list`);
      } else {
        this._onGoBackButton();
        browserHistory.push(`/manage-case/${caseDetail.id}/products/add`);
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onClickVrasPpcYes = async () => {
    try {
      const {
        tableName, setVhnPpcOtherCharge, setLoader, online,
        user: { name, territories, office }
      } = this.props;
      const caseDetail = await this._getCase();
      let vrasPpcValue = {};
      if (caseDetail.CustomerName !== null) {
        const vhnPpc = await getVhnPpcValue(caseDetail.CustomerName);
        if (typeof vhnPpc !== 'undefined') {
          vrasPpcValue = vhnPpc;
        }
      }
      const territoriesData = territories.find((item) => item.offices.some(
        (value) => value.id === office
      ));
      const officeData = territoriesData.offices.find((o) => o.id === office);
      const complainAppData = {
        CaseScheduleID: caseDetail.CaseScheduleID,
        OfficeName: officeData.name,
        RepCaseNo: caseDetail.RepCaseNo,
        UserName: name,
        ComplianceType: vrasPpcValue.VRAS_PPC === '1' ? 'VRAS-PPC' : 'VRAS-Other',
        UserResponse: 'YES',
        // ResponseDate: momentTz(new Date()).tz(SERVER_TIMEZONE).format('YYYY-MM-DD HH:mm:ss.SSS'),
        ResponseDate: momentTz(new Date()).format('YYYY-MM-DD HH:mm:ss.SSS'),
        Sync: online ? 0 : 1
      };
      setLoader(true);
      setVhnPpcOtherCharge(true);
      if (online) {
        await addComplianceAppData({
          CaseScheduleID: caseDetail.CaseScheduleID,
          ComplianceType: complainAppData.ComplianceType,
          UserResponse: complainAppData.UserResponse
        })
          .then(async (response) => {
            if (response.message === 'VHN Compliance added successsfully') {
              await insertComplianceApp(complainAppData);
              const newArrayOfObj = caseDetail.case_sets.map(({
                CasePlanId: CasePlanID,
                ...rest
              }) => ({
                CasePlanID,
                ...rest
              }));
              caseDetail.selectSets = newArrayOfObj;
              caseDetail.Submitted = '0';
              caseDetail.Synced = '0';
              caseDetail.VelysUsed = 'YES';
              await updateCase(caseDetail);
              updateTableWiseCaseByCaseId(caseDetail.id, caseDetail, tableName);
              if (complainAppData.ComplianceType === 'VRAS-PPC') {
                this._onGoBackButton();
                browserHistory.push(`/manage-case/${caseDetail.id}/products/add/other-charge`);
              } else {
                browserHistory.push(`/manage-case/${caseDetail.id}/products/add`);
              }
            }
          });
      } else {
        await insertComplianceApp(complainAppData);
        caseDetail.Submitted = '0';
        caseDetail.Synced = '0';
        caseDetail.VelysUsed = 'YES';
        caseDetail.Sync = 1;
        updateTableWiseCaseByCaseId(caseDetail.id, caseDetail, tableName);
        if (complainAppData.ComplianceType === 'VRAS-PPC') {
          this._onGoBackButton();
          browserHistory.push(`/manage-case/${caseDetail.id}/products/add/other-charge`);
        } else {
          this._onGoBackButton();
          browserHistory.push(`/manage-case/${caseDetail.id}/products/add`);
        }
      }
      setLoader(false);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onClickVrasPpcNo = async () => {
    try {
      const {
        tableName, setLoader, online,
        user: { name, territories, office }
      } = this.props;
      const caseDetail = await this._getCase();
      let vrasPpcValue = {};
      if (caseDetail.CustomerName !== null) {
        const vhnPpc = await getVhnPpcValue(caseDetail.CustomerName);
        if (typeof vhnPpc !== 'undefined') {
          vrasPpcValue = vhnPpc;
        }
      }
      const territoriesData = territories.find((item) => item.offices.some(
        (value) => value.id === office
      ));
      const officeData = territoriesData.offices.find((o) => o.id === office);
      const complainAppData = {
        CaseScheduleID: caseDetail.CaseScheduleID,
        OfficeName: officeData.name,
        RepCaseNo: caseDetail.RepCaseNo,
        UserName: name,
        ComplianceType: vrasPpcValue.VRAS_PPC === '1' ? 'VRAS-PPC' : 'VRAS-Other',
        UserResponse: 'NO',
        // ResponseDate: momentTz(new Date()).tz(SERVER_TIMEZONE).format('YYYY-MM-DD HH:mm:ss.SSS'),
        ResponseDate: momentTz(new Date()).format('YYYY-MM-DD HH:mm:ss.SSS'),
        Sync: online ? 0 : 1
      };
      setLoader(true);
      if (online) {
        await addComplianceAppData({
          CaseScheduleID: caseDetail.CaseScheduleID,
          ComplianceType: complainAppData.ComplianceType,
          UserResponse: complainAppData.UserResponse
        })
          .then(async (response) => {
            if (response.message === 'VHN Compliance added successsfully') {
              await insertComplianceApp(complainAppData);
              const newArrayOfObj = caseDetail.case_sets.map(({
                CasePlanId: CasePlanID,
                ...rest
              }) => ({
                CasePlanID,
                ...rest
              }));
              caseDetail.selectSets = newArrayOfObj;
              caseDetail.Submitted = '0';
              caseDetail.Synced = '0';
              caseDetail.VelysUsed = 'NO';
              await updateCase(caseDetail);
              updateTableWiseCaseByCaseId(caseDetail.id, caseDetail, tableName);
              this._onGoBackButton();
              browserHistory.push(`/manage-case/${caseDetail.id}/products/add`);
            }
          });
      } else {
        await insertComplianceApp(complainAppData);
        caseDetail.Submitted = '0';
        caseDetail.Synced = '0';
        caseDetail.VelysUsed = 'YES';
        caseDetail.Sync = 1;
        updateTableWiseCaseByCaseId(caseDetail.id, caseDetail, tableName);
        this._onGoBackButton();
        browserHistory.push(`/manage-case/${caseDetail.id}/products/add`);
      }
      setLoader(false);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onMrnPatientIdAdd = async (formData) => {
    try {
      const {
        notify, online, setLoader, tableName, setGoBack, goBack
      } = this.props;
      const { hospitalUseCustCaseIDStatus } = this.state;
      const caseDetail = await this._getCase();
      let vhnPpcValue = {};

      if (online && caseDetail && caseDetail.DGR === '1') {
        this.caseChangesNoLonger.show();
        return;
      }

      if (caseDetail.CustomerName !== null) {
        const vhnPpc = await getVhnPpcValue(caseDetail.CustomerName);
        if (typeof vhnPpc !== 'undefined') {
          vhnPpcValue = vhnPpc;
        }
      }

      if (!Object.keys(formData).length > 0) {
        this._onNextAddPatientIdOrMrn();
        return;
      }
      /* if (!online && scanner === true) {
        this.internalServerErrorModal.show();
      } */
      if (formData.hasOwnProperty('patientId')) {
        caseDetail.PatientID = (formData.patientId !== null || formData.patientId !== undefined)
          ? formData.patientId
          : null;
      }
      if (formData.hasOwnProperty('mrn')) {
        caseDetail.MRN = (formData.mrn !== null || formData.mrn !== undefined)
          ? formData.mrn
          : null;
      }

      if (online) {
        setLoader(true);
        const newArrayOfObj = caseDetail.case_sets.map(({
          CasePlanId: CasePlanID,
          ...rest
        }) => ({
          CasePlanID,
          ...rest
        }));
        caseDetail.selectSets = newArrayOfObj;
        caseDetail.Submitted = '0';
        caseDetail.Synced = '0';
        updateCase(caseDetail).then(async (responseJson) => {
          setLoader(false);
          const { status, message } = responseJson;
          if (status) {
            if (Object.keys(formData).length > 0) {
              // notify({ type: 'success', message });
              goBack.push(window.location.pathname);
              setGoBack(goBack);
              if ((caseDetail.case_products.length > 0
                || caseDetail.case_products.length === 0)
                && caseDetail.CaseType === 'HIP' && (vhnPpcValue.VHN_PPC === '1' || vhnPpcValue.VHN_Other === '1')) {
                if (hospitalUseCustCaseIDStatus) {
                  this._onOpenCustomerCaseModal();
                } else {
                  this._onAddVhnPpc();
                }
              } else if ((caseDetail.case_products.length > 0
                || caseDetail.case_products.length === 0)
                && caseDetail.CaseType === 'KNEE' && (vhnPpcValue.VRAS_PPC === '1' || vhnPpcValue.VRAS_Other === '1')) {
                if (hospitalUseCustCaseIDStatus) {
                  this._onOpenCustomerCaseModal();
                } else {
                  this._onAddVrasPpc();
                }
              } else if (caseDetail.case_products.length > 0) {
                if (hospitalUseCustCaseIDStatus) {
                  this._onOpenCustomerCaseModal();
                } else {
                  browserHistory.push(`/manage-case/${caseDetail.id}/products/list`);
                }
              } else {
                if (hospitalUseCustCaseIDStatus) {
                  this._onOpenCustomerCaseModal();
                } else {
                  browserHistory.push(`/manage-case/${caseDetail.id}/products/add`);
                }
              }
            }

            // Update into local db
            updateTableCaseByPrimaryId(caseDetail.id, caseDetail, tableName);
            updateTableWiseCaseByCaseId(caseDetail.RepCaseNo, caseDetail, tableName);
            // setLoader(false);
            this.setState({ caseDetail });
          } else {
            notify({ type: 'error', message });
          }
        });
      } else {
        setLoader(true);
        goBack.push(window.location.pathname);
        setGoBack(goBack);
        caseDetail.Sync = 1;
        if ((caseDetail.case_products.length > 0
          || caseDetail.case_products.length === 0)
          && caseDetail.CaseType === 'HIP' && (vhnPpcValue.VHN_PPC === '1' || vhnPpcValue.VHN_Other === '1')) {
          if (hospitalUseCustCaseIDStatus) {
            this._onOpenCustomerCaseModal();
          } else {
            this._onAddVhnPpc();
          }
        } else if ((caseDetail.case_products.length > 0
          || caseDetail.case_products.length === 0)
          && caseDetail.CaseType === 'KNEE' && (vhnPpcValue.VRAS_PPC === '1' || vhnPpcValue.VRAS_Other === '1')) {
          if (hospitalUseCustCaseIDStatus) {
            this._onOpenCustomerCaseModal();
          } else {
            this._onAddVrasPpc();
          }
        } else if (caseDetail.case_products.length > 0) {
          if (hospitalUseCustCaseIDStatus) {
            this._onOpenCustomerCaseModal();
          } else {
            browserHistory.push(`/manage-case/${caseDetail.id}/products/list`);
          }
        } else {
          if (hospitalUseCustCaseIDStatus) {
            this._onOpenCustomerCaseModal();
          } else {
            browserHistory.push(`/manage-case/${caseDetail.id}/products/add`);
          }
        }
        updateTableCaseByPrimaryId(caseDetail.id, caseDetail, tableName);
        updateTableWiseCaseByCaseId(caseDetail.RepCaseNo, caseDetail, tableName);
        setLoader(false);
        this.setState({ caseDetail });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onCustomerCaseIDAdd = async (formData) => {
    try {
      const {
        notify, online, setLoader, tableName, setGoBack, goBack
      } = this.props;
      const caseDetail = await this._getCase();
      let vhnPpcValue = {};

      if (online && caseDetail && caseDetail.DGR === '1') {
        this.caseChangesNoLonger.show();
        return;
      }

      if (caseDetail.CustomerName !== null) {
        const vhnPpc = await getVhnPpcValue(caseDetail.CustomerName);
        if (typeof vhnPpc !== 'undefined') {
          vhnPpcValue = vhnPpc;
        }
      }

      if (!Object.keys(formData).length > 0) {
        this._onNextCustomerCaseIDStatus();
        return;
      }

      if (formData.hasOwnProperty('CustCaseID')) {
        caseDetail.CustCaseID = (formData.CustCaseID !== null || formData.CustCaseID !== undefined)
          ? formData.CustCaseID
          : null;
      }

      if (online) {
        setLoader(true);
        const newArrayOfObj = caseDetail.case_sets.map(({
          CasePlanId: CasePlanID,
          ...rest
        }) => ({
          CasePlanID,
          ...rest
        }));
        caseDetail.selectSets = newArrayOfObj;
        caseDetail.Submitted = '0';
        caseDetail.Synced = '0';
        updateCase(caseDetail).then(async (responseJson) => {
          setLoader(false);
          const { status, message } = responseJson;
          if (status) {
            if (Object.keys(formData).length > 0) {
              goBack.push(window.location.pathname);
              setGoBack(goBack);
              if ((caseDetail.case_products.length > 0
                || caseDetail.case_products.length === 0)
                && caseDetail.CaseType === 'HIP' && (vhnPpcValue.VHN_PPC === '1' || vhnPpcValue.VHN_Other === '1')) {
                this._onAddVhnPpc();
              } else if ((caseDetail.case_products.length > 0
                || caseDetail.case_products.length === 0)
                && caseDetail.CaseType === 'KNEE' && (vhnPpcValue.VRAS_PPC === '1' || vhnPpcValue.VRAS_Other === '1')) {
                this._onAddVrasPpc();
              } else if (caseDetail.case_products.length > 0) {
                browserHistory.push(`/manage-case/${caseDetail.id}/products/list`);
              } else {
                browserHistory.push(`/manage-case/${caseDetail.id}/products/add`);
              }
            }

            // Update into local db
            updateTableCaseByPrimaryId(caseDetail.id, caseDetail, tableName);
            updateTableWiseCaseByCaseId(caseDetail.RepCaseNo, caseDetail, tableName);
            this.setState({ caseDetail });
          } else {
            notify({ type: 'error', message });
          }
        });
      } else {
        setLoader(true);
        goBack.push(window.location.pathname);
        setGoBack(goBack);
        caseDetail.Sync = 1;
        if ((caseDetail.case_products.length > 0
          || caseDetail.case_products.length === 0)
          && caseDetail.CaseType === 'HIP' && (vhnPpcValue.VHN_PPC === '1' || vhnPpcValue.VHN_Other === '1')) {
          this._onAddVhnPpc();
        } else if ((caseDetail.case_products.length > 0
          || caseDetail.case_products.length === 0)
          && caseDetail.CaseType === 'KNEE' && (vhnPpcValue.VRAS_PPC === '1' || vhnPpcValue.VRAS_Other === '1')) {
          this._onAddVrasPpc();
        } else if (caseDetail.case_products.length > 0) {
          browserHistory.push(`/manage-case/${caseDetail.id}/products/list`);
        } else {
          browserHistory.push(`/manage-case/${caseDetail.id}/products/add`);
        }
        updateTableCaseByPrimaryId(caseDetail.id, caseDetail, tableName);
        updateTableWiseCaseByCaseId(caseDetail.RepCaseNo, caseDetail, tableName);
        setLoader(false);
        this.setState({ caseDetail });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onCustomerCaseIDBack = async () => {
    try {
      const {
        online, setGoBack, goBack
      } = this.props;
      const caseDetail = await this._getCase();
      let vhnPpcValue = {};

      if (online && caseDetail && caseDetail.DGR === '1') {
        this.caseChangesNoLonger.show();
        return;
      }

      if (caseDetail.CustomerName !== null) {
        const vhnPpc = await getVhnPpcValue(caseDetail.CustomerName);
        if (typeof vhnPpc !== 'undefined') {
          vhnPpcValue = vhnPpc;
        }
      }

      goBack.push(window.location.pathname);
      setGoBack(goBack);

      if ((caseDetail.case_products.length > 0
        || caseDetail.case_products.length === 0)
        && caseDetail.CaseType === 'HIP' && (vhnPpcValue.VHN_PPC === '1' || vhnPpcValue.VHN_Other === '1')) {
        this._onAddVhnPpc();
      } else if ((caseDetail.case_products.length > 0
        || caseDetail.case_products.length === 0)
        && caseDetail.CaseType === 'KNEE' && (vhnPpcValue.VRAS_PPC === '1' || vhnPpcValue.VRAS_Other === '1')) {
        this._onAddVrasPpc();
      } else if (caseDetail.case_products.length > 0) {
        browserHistory.push(`/manage-case/${caseDetail.id}/products/list`);
      } else {
        browserHistory.push(`/manage-case/${caseDetail.id}/products/add`);
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onSubmitProductCaseNo = () => {
    try {
      this.zeroProductSubmitModal.hide();
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onSubmitProductCaseYes = async () => {
    try {
      const {
        notify, setLoader, tableName, user: { name }, params,
        team: { dgrRequired },
      } = this.props;
      const { caseDetail } = this.state;

      // if (caseDetail && caseDetail.DGR === '1') {
      //   // this.zeroProductSubmitModal.hide();
      //   this.caseChangesNoLonger.show();
      //   return false;
      // }

      let responseJson = {};
      const {
        CaseScheduleID, CaseDate, CaseTime, CustomerNo, CustomerName, SurgeonName,
        PatientID, ProcedureType, CaseType, Side, Comments, RepNotes, ProductNotes,
        ProductSubmitted, RepPONumber, Submitted, CoverRep, ChangeRep, DGRUpload,
        MRN, Gender, Age, ACMPlannedParts, ACMSelectedParts, Height, Weight, selectedSets,
        case_products, ...partialObject
      } = caseDetail;
      const subset = {
        CaseScheduleID,
        CaseDate,
        CaseTime,
        CustomerNo,
        CustomerName,
        SurgeonName,
        PatientID,
        ProcedureType,
        CaseType,
        Side,
        Comments,
        RepNotes,
        ProductNotes,
        ProductSubmitted,
        RepPONumber,
        Submitted,
        CoverRep,
        ChangeRep: name,
        DGRUpload,
        MRN,
        Gender,
        Age,
        ACMPlannedParts,
        ACMSelectedParts,
        Height,
        Weight,
        selectedSets
      };

      const newArrayOfObj = partialObject.case_sets.map(({
        CasePlanId: CasePlanID,
        ...rest
      }) => ({
        CasePlanID,
        ...rest
      }));
      subset.selectedSets = newArrayOfObj;

      if (caseDetail.case_products.length > 0 && dgrRequired > 0) {
        if (caseDetail.case_dgrs.length === 0) {
          subset.DGRUpload = '1';
        }
        // subset.DGRUpload = '2';
        // } else if (!(caseDetail.case_products.length > 0) || !(dgrRequired > 0)) {
        //   if (caseDetail.case_dgrs.length > 0) {
        //     subset.DGRUpload = '2';
        //   }
        // subset.DGRUpload = '1';
      } else if (caseDetail.case_dgrs.length > 0) {
        subset.DGRUpload = '2';
      }

      if (typeof caseDetail.case_products !== 'undefined' && caseDetail.case_products.length > 0) {
        subset.ProductNotes = (subset.ProductNotes === '' || subset.ProductNotes === null || subset.ProductNotes === 'No products used') ? '' : subset.ProductNotes;
      } else {
        subset.ProductNotes = (subset.ProductNotes === '' || subset.ProductNotes === null) ? '' : subset.ProductNotes;
      }

      subset.Submitted = '1';
      // subset.ProductSubmitted = '1';
      if (subset.ProductSubmitted === '0') {
        subset.ProductSubmitted = '1';
      } else {
        if (typeof caseDetail.case_products !== 'undefined' && caseDetail.case_products.length > 0) {
          subset.ProductSubmitted = '1';
        }
      }

      setLoader(true);
      await updateCase(subset);
      setLoader(false);
      responseJson = await listSingleCase(caseDetail.CaseScheduleID);
      const { message, status } = responseJson;
      if (status) {
        const caseDetails = responseJson.data[0];
        caseDetails.id = parseInt(caseDetail.id, 10);
        caseDetails.CaseDate = caseDetail.CaseDate;
        caseDetails.CaseTime = caseDetail.CaseTime;
        // Update the response when update API change
        updateTableWiseCaseByCaseId(caseDetails.RepCaseNo, caseDetails, tableName);
        const caseRes = await this._getCase();
        this.setState({
          caseRes
        });
        this.zeroProductSubmitModal.hide();
        this.caseSubmittedModal.show();
        setTimeout(
          () => this.caseSubmittedModal.hide(),
          2000
        );
        if (params.hasOwnProperty('caseId')) {
          await this._getCaseById();
        }
      } else {
        notify({ type: 'error', message });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onCaseSubmitted = () => {
    try {
      this.alreadySubmittedCase.show();
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onSubmitCase = async () => {
    try {
      const {
        notify, online, setLoader, tableName, user: { name }, params
      } = this.props;
      const { caseDetail } = this.state;

      if (online) {
        if (caseDetail.case_products.length >= 0 && caseDetail.ProductSubmitted === '0') {
          this.zeroProductSubmitModal.show();
        } else {
          setLoader(true);
          let responseJson = {};
          const {
            CaseScheduleID, CaseDate, CaseTime, CustomerNo, CustomerName, SurgeonName,
            PatientID, ProcedureType, CaseType, Side, Comments, RepNotes, ProductNotes,
            ProductSubmitted, RepPONumber, Submitted, CoverRep, ChangeRep, DGRUpload,
            MRN, Gender, Age, ACMPlannedParts, ACMSelectedParts, Height, Weight, selectedSets,
            case_dgrs, case_products,
            ...partialObject
          } = caseDetail;
          const subset = {
            CaseScheduleID,
            CaseDate,
            CaseTime,
            CustomerNo,
            CustomerName,
            SurgeonName,
            PatientID,
            ProcedureType,
            CaseType,
            Side,
            Comments,
            RepNotes,
            ProductNotes,
            ProductSubmitted,
            RepPONumber,
            Submitted,
            CoverRep,
            ChangeRep: name,
            DGRUpload,
            MRN,
            Gender,
            Age,
            ACMPlannedParts,
            ACMSelectedParts,
            Height,
            Weight,
            selectedSets
          };

          if (caseDetail.case_products.length === 0 && caseDetail.case_dgrs.length === 0 && caseDetail.Submitted === '0') {
            subset.DGRUpload = '0';
          }

          subset.Submitted = '1';
          subset.ProductSubmitted = (((case_dgrs.length > 0 || case_products.length > 0) && (subset.ProductSubmitted === '0')) ? '1'
            : ((case_dgrs.length > 0 || case_products.length === 0) && (subset.ProductSubmitted === '1')) ? '1' : null);
          subset.ProductNotes = (subset.ProductNotes === '' || subset.ProductNotes === null) ? '' : subset.ProductNotes;
          // subset.ProductSubmitted = (((case_dgrs.length > 0 || case_products.length >= 0)
          // && (subset.ProductSubmitted === '0')) ? '1' : null);
          // subset.ProductSubmitted = '1';
          if (subset.ProductSubmitted === '0') {
            subset.ProductSubmitted = '1';
          } else {
            if (typeof caseDetail.case_products !== 'undefined' && caseDetail.case_products.length > 0) {
              subset.ProductSubmitted = '1';
            }
          }
          subset.Synced = (subset.Synced === '1' ? '0' : subset.Synced);

          const newArrayOfObj = partialObject.case_sets.map(({
            CasePlanId: CasePlanID,
            ...rest
          }) => ({
            CasePlanID,
            ...rest
          }));
          subset.selectedSets = newArrayOfObj;
          await updateCase(subset);
          setLoader(false);
          responseJson = await listSingleCase(caseDetail.CaseScheduleID);
          const { message, status } = responseJson;
          if (status) {
            const caseDetails = responseJson.data[0];
            caseDetails.id = parseInt(caseDetail.id, 10);
            caseDetails.CaseDate = caseDetail.CaseDate;
            caseDetails.CaseTime = caseDetail.CaseTime;
            // Update the response when update API change
            updateTableWiseCaseByCaseId(caseDetails.RepCaseNo, caseDetails, tableName);
            const caseRes = await getTableCaseByCaseId(caseDetails.id, tableName);
            this.setState({
              caseRes
            });
            this.caseSubmittedModal.show();
            setTimeout(
              () => this.caseSubmittedModal.hide(),
              2000
            );
            if (params.hasOwnProperty('caseId')) {
              await this._getCaseById();
            }
          } else {
            notify({ type: 'error', message });
          }
        }
      } else {
        // caseDetail.Sync = 1;
        // caseDetail.Submitted = '1';
        // caseDetail.ProductSubmitted = '1';
        // caseDetail.Synced = (caseDetail.Synced === '1' ? '0' : caseDetail.Synced);
        // updateTableCaseByPrimaryId(caseDetail.id, caseDetail, tableName);
        // setLoader(false);
        notify({
          type: 'error',
          message: 'You must have an internet connection. Please check your connection and try again.',
          time: 5
        });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onManageDetailBack = async () => {
    try {
      const { goBack } = this.props;
      const caseRes = await this._getCase();
      const { caseDetail } = this.state;
      if (JSON.stringify(caseRes) !== JSON.stringify(caseDetail)) {
        this.setState({
          previousPage: 'previousPage'
        });
        this.saveChangesConfirmation.show();
      } else {
        onGoBack(goBack);
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onBackCancel = async () => {
    try {
      const { goBack } = this.props;
      onGoBack(goBack);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onFocusAndBlur = () => {
    try {
      const { isEditDetail } = this.state;
      (!isEditDetail) ? window.$('#onFocusEdit').blur() : window.$('#onFocusEdit').focus();
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onRepNotesFocusAndBlur = () => {
    try {
      const { isEditDetail } = this.state;
      if (!isEditDetail) {
        window.$('#repNote').blur();
      } else {
        const html = window.$('#repNote').val();
        window.$('#repNote').focus().val('').val(html);
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onOfficeNotesFocusAndBlur = () => {
    try {
      const { isEditDetail } = this.state;
      if (!isEditDetail) {
        window.$('#officeNote').blur();
      } else {
        const html = window.$('#officeNote').val();
        window.$('#officeNote').focus().val('').val(html);
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onHospitalFocusAndBlur = () => {
    try {
      const { isEditDetail } = this.state;
      (!isEditDetail) ? window.$('#hospitalsEle').blur() : window.$('#hospitalsEle').focus();
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onSelect2FocusAndBlur = () => {
    try {
      const { isEditDetail } = this.state;
      (!isEditDetail) ? window.$('#onSelect2FocusEdit').blur() : window.$('#onSelect2FocusEdit').focus();
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _getScreenWidth = () => {
    this.setState({ screenWidth: window.screen.width });
  }

  // _onClickDrnModalNo = () => {
  //   try {
  //     const { caseDetail } = this.state;
  //     if (caseDetail.case_products.length >= 0 && caseDetail.ProductSubmitted === '0') {
  //       this.zeroProductSubmitModal.show();
  //     }
  //   } catch (e) {
  //     Bugsnag.notify(e);
  //   }
  // }

  _getFiles = async () => {
    try {
      const { caseDetail: { case_xrays } } = this.state;
      const XrayIds = (case_xrays.length > 0) ? case_xrays.map((r) => r.XRayID) : [];
      if (XrayIds.length > 0) {
        const {
          user, setLoader, notify, team, online
        } = this.props;
        const generateTimedURLData = {
          team: team.name,
          entity_type: 'xrays',
          entity_id: JSON.stringify(XrayIds),
          token: user.token,
          key: user.userKey
        };
        setLoader(true);
        if (online) {
          generateBulkTimedURL(generateTimedURLData).then((responseJson) => {
            setLoader(false);
            const { status, message, data } = responseJson;
            if (status) {
              if (message.length > 0) {
                // notify({ type: 'success', message });
              }
              const fileData = data !== undefined && data.map((file) => {
                const profile = case_xrays.find((d) => (file.entity_id === d.XRayID));
                // const newItem = { fileType: profile.Filename };
                // boxData.push();
                const fileext = profile.Filename.split('.').pop();
                const docData = {
                  src: file.url,
                  width: 1,
                  height: 1,
                  title: profile.Name,
                  fileType: fileext.toLowerCase() === 'pdf' ? 'pdf' : fileext.toLowerCase() === 'txt' ? 'txt' : 'image',
                  order: fileext.toLowerCase() === 'pdf' ? 1 : 0
                };
                return docData;
              });
              // const sortFileData = _.orderBy(fileData, ['order'], ['desc']);
              const sortFilesData = _.chain(fileData)
                .orderBy(['order'], ['desc'])
                .groupBy('fileType')
                .map((value, key) => ({ type: key, files: value }))
                .value();
              this.setState({ xRayFileUrlData: sortFilesData });
              // window.open(data, '', 'width=900, height=900');
            } else {
              notify({ type: 'error', message });
            }
          });
        } else {
          this.setState({ xRayFileUrlData: case_xrays });
          setLoader(false);
        }
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  /* async UNSAFE_componentWillReceiveProps(nextProps) {
    const { online } = this.props;
    if (online !== nextProps.online) {

    }
  } */

  _getCase = async () => {
    const {
      params: { caseId }, tableName, setLoader, notify
    } = this.props;
    try {
      setLoader(true);
      // Check if the case is already in the db
      const caseResByCaseId = await getTableCaseByCaseId(caseId, tableName);
      if (caseResByCaseId) {
        setLoader(false);
        return caseResByCaseId;
      }

      // Check if the case is already in the db by schedule id
      const caseResByScheduleId = await getCaseByCaseScheduleID(Number(caseId));
      if (caseResByScheduleId) {
        setLoader(false);
        return caseResByScheduleId;
      }

      // If case is not in the db, fetch from remote
      const caseResFromRemote = await listSingleCase(caseId);
      if (!caseResFromRemote?.data?.length) {
        notify({ type: 'error', message: 'Case not found in currently active team.' });
        browserHistory.push('/manage-cases');
        return;
      }
      const resId = await singleManageCaseAdd(caseResFromRemote.data[0]);
      updateCaseByPrimaryId(resId, caseResFromRemote.data[0]);
      const caseSavedToDb = await getTableCaseByCaseId(resId, tableName);
      if (caseSavedToDb) {
        setLoader(false);
        return caseSavedToDb;
      }
    } catch (e) {
      Bugsnag.notify(e);
    } finally {
      setLoader(false);
    }
  }

  async UNSAFE_componentWillMount() {
    try {
      const { params } = this.props;
      if (params.hasOwnProperty('caseId')) {
        await this._getCaseById();
      }

      const caseRes = await this._getCase();

      if (Object.keys(caseRes).length > 0) {
        this.setState({
          caseRes
        });
      }
      await this._getScreenWidth();
      await this._getSurgeon();
      await this._getCaseType();
      await this._getProcedureTypes();
      await this._getTeamReps();
      await this._getSideType();
      await this._getGenderType();
      await this._getHospital();
      await this._getFiles();
      $(document).on('focus', '.select2-selection.select2-selection--single', function () {
        $(this).closest('.select2-container').siblings('select:enabled').select2('open');
      });
      // steal focus during close - only capture once and stop propogation
      // $('select.select2').on('select2:closing', (e) => {
      //   $(e.target).data('select2').$selection.one('focus focusin', (ee) => {
      //     ee.stopPropagation();
      //   });
      // });
      // $('select').select2({
      //   minimumResultsForSearch: -1
      // })
      //   .on('select2-opening', function () {
      //     $(this).siblings('.select2-container')
      //     .find('.select2-search, .select2-focusser').remove();
      //   });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  render() {
    const {
      caseDetail, isEditDetail, sides, coverReps, types,
      procedures, surgeons, hospitals, genders, selectedDate,
      selectedTime, caseRes, screenWidth, xRayFileUrlData
    } = this.state;

    const { user } = this.props;

    return (
      <div className="site-wrapper resizer-class">
        <Header
          title="Case Details"
          goBack={this._onManageDetailBack}
          customRightSide={(
            <div style={{
              display: 'flex',
              flexDirection: 'row',
              gap: '20px',
              width: '100%',
              justifyContent: 'flex-end'
            }}
            >
              {!Object.values(isEditDetail).some((key) => key === true) && (
                <Link
                  className="btn-link sub-header-text cursor-pointer"
                  style={{ whiteSpace: 'nowrap' }}
                  onClick={() => this._onPrint()}
                >
                  <img style={{ width: '20px' }} src={Printer} alt="edit pencil" />
                </Link>
              )}
              <Link
                className="btn-link sub-header-text cursor-pointer"
                style={{ whiteSpace: 'nowrap' }}
                onClick={() => this._onGoBack()}
              >
                {Object.values(isEditDetail).some((key) => key === true) ? 'Save' : 'Edit'}
              </Link>
            </div>
          )}
        />
        <EditCaseDetail
          key={Math.random()}
          onSetsClick={this._onSetsClick}
          onGoBack={this._onGoBack}
          onBillingDetails={this._onBillingDetails}
          caseDetail={caseDetail}
          isEditDetail={isEditDetail}
          onChangeCaseDetail={(key, value) => this._onChangeCaseDetail(key, value)}
          onEditCaseDetail={(key, value) => this._onEditCaseDetail(key, value)}
          sides={sides}
          coverReps={coverReps}
          types={types}
          procedures={procedures}
          surgeons={surgeons}
          hospitals={hospitals}
          genders={genders}
          selectedDate={selectedDate}
          selectedTime={selectedTime}
          caseId={caseDetail.id}
          caseRes={caseRes}
          refreshCaseData={this._getCaseById}
          onProduct={this._onAddPatientIdOrMrn}
          onSubmitCase={this._onSubmitCase}
          onCaseSubmitted={this._onCaseSubmitted}
          onCancelCase={this._onCancelCase}
          user={user}
          AddVhnPpc={this._onAddVhnPpc}
          onCustomerNo={this._getCustomerNo}
          screenWidth={screenWidth}
          AddVrasPpc={this._onAddVrasPpc}
          xRayFileUrlData={xRayFileUrlData}
          onCustomerCaseAdd={this._onOpenCustomerCaseModal}
        />
        <CancelCaseModal
          onCancelCase={this._onCaseCancel}
          onCaseRowAcmCase={caseDetail}
          onCancelCaseBack={this._onCancelCaseBack}
        />
        <CaseSubmitted
          caseDetail={caseDetail}
        />
        <TypeChangeConfirmationModal
          caseRes={caseRes}
          onSaveChanges={this._onSaveChanges}
          onCancelTypeChange={this._onCancelTypeChange}
        />
        <MrnOrPatientIdModal caseId={caseDetail.id} onSubmit={this._onMrnPatientIdAdd} />
        <RequiredMrnOrPatientId onClickOk={this._onAddPatientIdOrMrn} />
        <ZeroProductSubmitModal
          onSubmitProductCaseYes={this._onSubmitProductCaseYes}
          onSubmitProductCaseNo={this._onSubmitProductCaseNo}
          caseDetail={caseDetail}
        />
        <AgeInputLimitModal onAngeInputChange={this._onAngeInputChange} editDetail />
        <AlreadySubmittedCase />
        <CaseChangesNoLonger />
        <QuickEditChangesNoLonger />
        <PatientAndMrnEditOffline onClickOk={this._onClickOk} />
        <ACMProductGoBackModal
          onCancel={this._onBackCancel}
          onSave={this._onSaveChanges}
        />
        <VhnPpcModal
          onClickNo={this._onClickVhnPpcNo}
          onClickYes={this._onClickVhnPpcYes}
        />
        <VrasPpcModal
          onClickNo={this._onClickVrasPpcNo}
          onClickYes={this._onClickVrasPpcYes}
        />
        <CustCaseIDModal
          onSubmit={this._onCustomerCaseIDAdd}
          onBack={this._onCustomerCaseIDBack}
        />
        <RequiredCustCaseID onClickOk={this._onCustomerCaseIDStatus} />
      </div>
    );
  }
}

export default withVhnPpcOtherCharge(
  withUser(
    withSetsListStateStorage(
      withTableName(
        withLoader(
          withTeam(
            withSelectedSetsPayload(
              withOnline(
                withNotify(
                  withSelectCaseDate(
                    withGoBack(
                      withThemeColor(
                        ManageCaseDetails
                      )
                    )
                  )
                )
              )
            )
          )
        )
      )
    )
  )
);
